import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { Modal } from '../Component.js';
import { Content } from '../components/content/Component.js';
import { Controls } from '../components/controls/Component.js';
import { Footer } from '../components/footer/Component.js';
import { Header } from '../components/header/Component.js';

var ModalDesktopComponent = forwardRef(function (props, ref) { return (React.createElement(Modal, __assign({}, props, { ref: ref, view: 'desktop' }))); });
var ModalDesktop = Object.assign(ModalDesktopComponent, {
    Content: Content,
    Header: Header,
    Footer: Footer,
    Controls: Controls,
});

export { ModalDesktop };
